<script lang="ts" setup>
import {
  ButtonIcon,
  IconChevronLeft,
  IconChevronRight
} from '@hobbii/hobbii-ui';
import { ref } from 'vue';

defineEmits<{
  (e: 'prev-gallery'): void;
  (e: 'next-gallery'): void;
}>();

defineProps<{
  labelPrev: string;
  labelNext: string;
}>();

const root = ref<HTMLElement | null>(null);
</script>
<template>
  <div ref="root" class="relative size-full p-14">
    <ButtonIcon
      theme="light"
      :label="labelPrev"
      size="md"
      class="absolute left-2 top-1/2 -translate-y-1/2"
      @click="$emit('prev-gallery')"
    >
      <IconChevronLeft class="text-2xl" />
    </ButtonIcon>
    <slot />

    <ButtonIcon
      theme="light"
      :label="labelNext"
      size="md"
      class="absolute right-2 top-1/2 -translate-y-1/2"
      @click="$emit('next-gallery')"
    >
      <IconChevronRight class="text-2xl" />
    </ButtonIcon>
  </div>
</template>
